export class Tabs
{
    constructor()
    {
        this.section = document.querySelector('.fast-links');
        this.data = JSON.parse(this.section.dataset.section);

        this.items = this.data.reduce((acc, section) => {
            if (section.ITEMS.length) {
                const items = section.ITEMS.forEach((item) => {
                    if (item) {
                        acc.push(item);
                    }
                });
            }
            return acc;
        }, []);

        this._init();
    }

    _init() {
        if (window.screen.width > 768) {
            this._createTab();
        } else {
            this._createTabMobile();
        }

        window.addEventListener('resize', () => {
            this.section.textContent = '';
            if (window.screen.width > 768) {
                this._createTab();
            } else {
                this._createTabMobile();
            }
        });
    }

    _createTabMobile = () => {
        const swiper = document.createElement('div');
        const swiperWrapper = document.createElement('div');
        const chunkSize = 2;
        let itemsTwo = [];

        swiper.classList.add('swiper');
        swiper.classList.add('fast-links-tab-mobile');

        swiperWrapper.classList.add('swiper-wrapper');
        swiperWrapper.classList.add('fast-links-tab-mobile__slider');

        for (let i = 0; i < this.items.length; i += chunkSize) {
            const chunk = this.items.slice(i, i + chunkSize);
            itemsTwo.push(chunk);
        }

        itemsTwo.forEach((itemTwo) => {
            const swiperSlide = document.createElement('div');
            const cart = document.createElement('div');

            swiperSlide.classList.add('swiper-slide');
            swiperSlide.classList.add('fast-links-tab-mobile__item');
            cart.classList.add('fast-links-tab-mobile-cart');

            itemTwo.forEach((element) => {
                const cartItem = document.createElement('div');
                const cartLink = document.createElement('a');
                const cartImage = document.createElement('img');

                cartItem.classList.add('fast-links-tab-mobile-cart__item');
                cartLink.classList.add('fast-links-tab-mobile-cart__link');
                cartImage.classList.add('fast-links-tab-mobile-cart__image');

                cartLink.setAttribute('href', element.LINK);
                cartImage.setAttribute('src', element.IMAGE.src);
                cartImage.setAttribute('alt', element.NAME);

                cartLink.append(cartImage);
                cartItem.append(cartLink);
                cart.append(cartItem);
            });

            swiperSlide.append(cart);
            swiperWrapper.append(swiperSlide);
        });

        swiper.append(swiperWrapper);
        this.section.append(swiper);

        this._createSlider(swiper);
    }

    _createTab = () => {
        const tab = document.createElement('ul');

        tab.classList.add('fast-links-tab');

        this.data.forEach((tabItem, i) => {
            const li = document.createElement('li');
            const button = document.createElement('button');

            li.classList.add('fast-links-tab__item');
            button.classList.add('fast-links-tab__link');

            if (i === 0) {
                button.classList.add('active')
            }

            button.dataset.section = tabItem.CODE;
            button.textContent = tabItem.NAME;

            li.append(button);
            tab.append(li);
        });

        this.section.append(tab);

        this._createItems();
    }

    _createItems = () => {
        const tabs = document.createElement('div');

        tabs.classList.add('fast-links-tabs');

        this.data.forEach((tabsItem, i) => {
            const item = document.createElement('div');

            item.classList.add('fast-links-tabs__item');
            item.dataset.section = tabsItem.CODE;

            if (i === 0) {
                item.classList.add('active')
            }

            if (tabsItem.ITEMS) {
                const items = document.createElement('ul');

                items.classList.add('fast-links-tabs__items');

                tabsItem.ITEMS.forEach((element) => {
                    const li = document.createElement('li');
                    const a = document.createElement('a');
                    const image = document.createElement('img');

                    li.classList.add('fast-links-tabs__cart');
                    a.classList.add('fast-links-tabs__link');
                    image.classList.add('fast-links-tabs__image');

                    a.setAttribute('href', element.LINK);
                    image.setAttribute('src', element.IMAGE.src);
                    image.setAttribute('alt', element.NAME);

                    li.append(a);
                    a.append(image);
                    items.append(li);
                });

                item.append(items);
            }
            this.section.append(item);
        });

        this._addEventListener();
    }

    _clickTabs = () => {
        const buttonTabs = this.section.querySelectorAll('.fast-links-tab__link');
        const itemTabs = this.section.querySelectorAll('.fast-links-tabs__item');

        if (buttonTabs.length) {
            buttonTabs.forEach((button) => {
                button.addEventListener('click', (event) => {
                    const target = event.target;
                    const sectionCode = target.dataset.section;

                    buttonTabs.forEach((button) => {
                        if (button === target) {
                            button.classList.add('active');
                        } else {
                            button.classList.remove('active');
                        }
                    });

                    itemTabs.forEach((item) => {
                        const itemSection = item.dataset.section;

                        if (sectionCode === itemSection) {
                            item.classList.add('active');
                        } else {
                            item.classList.remove('active');
                        }
                    });
                });
            });
        }
    }

    _createSlider = (slider) => {
        new Swiper(slider, {
            slidesPerView: 'auto',
            spaceBetween: 12
        });
    }

    _addEventListener = () => {
        this._clickTabs();
    }
}

export default Tabs;
